module.exports = __webpack_public_path__ + "img/jackpot.98c289fe.png";